import { useState } from 'react';
import { useMediaStore } from '../../stores/mediaStore';
import { useOffice } from '../office/OfficeContext';
import './av.css';

/**
 * Eingehende Klingelversuche als Toast oben-mittig: Annehmen startet die
 * Medien (call:accepted kommt vom Server an beide Seiten), Ablehnen laesst
 * das Paar pending.
 */
export function RingToast() {
  const peers = useMediaStore((s) => s.peers);
  const incoming = Object.values(peers).filter((p) => p.ring === 'incoming');
  if (incoming.length === 0) return null;

  return (
    <div className="ring-toasts">
      {incoming.map((peer) => (
        <RingToastEntry key={peer.peerId} peerId={peer.peerId} displayName={peer.displayName} />
      ))}
    </div>
  );
}

function RingToastEntry({ peerId, displayName }: { peerId: string; displayName: string }) {
  const { socket } = useOffice();
  const setPeerRing = useMediaStore((s) => s.setPeerRing);
  const [error, setError] = useState<string | null>(null);

  const accept = (): void => {
    socket.emit('call:accept', { to: peerId }, (res) => {
      // call:accepted raeumt den Ring-Status ueber den RtcManager ab
      if (!res.ok) setError(res.error);
    });
  };

  const decline = (): void => {
    socket.emit('call:decline', { to: peerId });
    setPeerRing(peerId, 'none');
  };

  return (
    <div className="ring-toast" role="alertdialog" aria-label={`${displayName} moechte sprechen`}>
      <span className="ring-toast__bell" aria-hidden="true">🔔</span>
      <span className="ring-toast__text">
        <strong>{displayName}</strong> möchte sprechen
        {error && <small className="ring-toast__error">{error}</small>}
      </span>
      <div className="ring-toast__actions">
        <button className="ring-toast__accept" onClick={accept}>
          Annehmen
        </button>
        <button className="ring-toast__decline" onClick={decline}>
          Ablehnen
        </button>
      </div>
    </div>
  );
}
